import {
  AttachmentStandardSettings
} from 'apps/studio/components/settings/fields/Attachment/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Attachment/advanced'

export const AttachmentSettings = [
  FieldSettingsPanel(AttachmentStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  AdvancedPanel,
  // TODO: add AttachFileToggle as well from builder's advanced.js
]
